import { Component, OnInit, ElementRef, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-coach-directory',
  templateUrl: './coach-directory.component.html',
  styleUrls: ['./coach-directory.component.scss']
})
export class CoachDirectoryComponent implements OnInit {

  loading: boolean = true;

  constructor(private elementRef: ElementRef) { }

  //ngAfterViewInit() {
  //    this.elementRef.nativeElement.querySelector('div')
  //        .addEventListener('click', this.onClick.bind(this));
  //}

  //onClick(event) {
  //    console.log(event);
  //}

  ngOnInit() {
      window.addEventListener('click', this.scroll, true); //third parameter
      setTimeout(() => {
          this.loading = false;
          console.log('auto hide');
      }, 3000);
  }

  ngOnDestroy() {
      window.removeEventListener('click', this.scroll, true);
  }

  scroll = (): void => {
      //handle your scroll here
      //notice the 'odd' function assignment to a class field
      //this is used to be able to remove the event listener
      console.log('event');
  };

    

  hideLoading() {
      this.loading = false;
  }

}
